import * as THREE from 'three';

const W = 240;
const H = 176;
const SCALE = 2;

/** Renders an isometric close-up of `target` to a small JPEG data URL for history previews. */
export function renderThumbnail(renderer: THREE.WebGLRenderer, scene: THREE.Scene, target: THREE.Object3D, hide: THREE.Object3D[]): string {
  const box = new THREE.Box3().setFromObject(target);
  if (box.isEmpty()) return '';
  const center = box.getCenter(new THREE.Vector3());
  const radius = box.getSize(new THREE.Vector3()).length() / 2;

  const camera = new THREE.PerspectiveCamera(28, W / H, 1, 5000);
  const dist = radius / Math.sin(THREE.MathUtils.degToRad(28) / 2) * 0.82;
  camera.position.copy(center).addScaledVector(new THREE.Vector3(1, 0.8, 1.3).normalize(), dist);
  camera.lookAt(center);

  const rt = new THREE.WebGLRenderTarget(W * SCALE, H * SCALE);
  rt.texture.colorSpace = THREE.SRGBColorSpace;

  const visibility = hide.map((o) => o.visible);
  hide.forEach((o) => o.visible = false);
  const background = scene.background;
  scene.background = new THREE.Color('#eceef1');

  renderer.setRenderTarget(rt);
  renderer.render(scene, camera);
  const pixels = new Uint8Array(W * SCALE * H * SCALE * 4);
  renderer.readRenderTargetPixels(rt, 0, 0, W * SCALE, H * SCALE, pixels);
  renderer.setRenderTarget(null);

  scene.background = background;
  hide.forEach((o, i) => o.visible = visibility[i]);
  rt.dispose();

  // Flip vertically into a full-size canvas, then downsample for smooth edges.
  const big = document.createElement('canvas');
  big.width = W * SCALE;
  big.height = H * SCALE;
  const bctx = big.getContext('2d');
  if (!bctx) return '';
  const img = bctx.createImageData(W * SCALE, H * SCALE);
  const row = W * SCALE * 4;
  for (let y = 0; y < H * SCALE; y++) img.data.set(pixels.subarray(y * row, (y + 1) * row), (H * SCALE - 1 - y) * row);
  bctx.putImageData(img, 0, 0);

  const small = document.createElement('canvas');
  small.width = W;
  small.height = H;
  const sctx = small.getContext('2d');
  if (!sctx) return '';
  sctx.imageSmoothingQuality = 'high';
  sctx.drawImage(big, 0, 0, W, H);
  return small.toDataURL('image/jpeg', 0.86);
}
